<template>
  <li
    v-if="$route.meta.module"
    :class="`item ${$route.meta?.module === item.name ? 'active' : ''}
    `"
    :data-umami-event="`${item.name}_menu`"
    @click="goToPage"
    :key="$route.path"
  >
    <Icon v-if="hasNewNotifications" iconName="bellsWithDot" />
    <Picture v-else class="item__logo" :url="item.icon" :alt="item.name" />
    <transition name="fade">
      <span v-show="isOpen">
        {{ item.lbl.value }}
        <template v-if="hasNewNotifications"
          >({{ offsets.new_notifications }})</template
        >
      </span>
    </transition>
  </li>
  <li
    v-else
    :class="`item ${$route.params?.module === item.name ? 'active' : ''}
    `"
    :data-umami-event="`${item.name}_menu`"
    @click="goToPage"
    :key="$route.path"
  >
    <Icon v-if="hasNewNotifications" iconName="bellsWithDot" />
    <Picture v-else class="item__logo" :url="item.icon" :alt="item.name" />
    <transition name="fade">
      <span v-show="isOpen">
        {{ item.lbl.value }}
        <template v-if="hasNewNotifications"
          >({{ newNotifications.length }})</template
        >
      </span>
    </transition>
  </li>
</template>
<script>
import { store } from '@/store';
import { INTENT_AREA } from '@/utils/constants';
import { mixin } from '@/utils/mixins';
import Icon from 'Elements/Icon/Icon';
import Picture from 'Elements/Picture/Picture';

export default {
  mixins: [mixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    offsets() {
      return store.state.notifications.offsets;
    },
    hasNewNotifications() {
      return (
        this.item.name === 'Notifications' && this.newNotifications?.length
      );
    },
    newNotifications() {
      const newNotifications = store.state.notifications?.newNotifications
        ?.length
        ? store.state.notifications?.newNotifications
        : store.state.notifications?.notifications?.data?.data?.data?.rows ||
          [];
      const readed = store.state.notifications?.readed;
      const readedPush = store.state.notifications?.readedPush;
      if (
        newNotifications.length &&
        !store.state.notifications?.newNotifications?.length
      ) {
        return newNotifications?.filter(
          item => !readed.includes(item.ID) && item.IS_READ == 0
        );
      } else if (
        newNotifications.length &&
        store.state.notifications?.newNotifications?.length
      ) {
        return newNotifications
          ?.filter(
            item => !readed.includes(item.id) && !readedPush.includes(item.id)
          )
          ?.slice(-3);
      }
      return newNotifications;
    }
  },
  methods: {
    goToPage() {
      // Отправляем статистику клика в umami
      if (window.umami.track) {
        window.umami.track(this.item.name);
      }

      if (
        this.$router.options.routes.some(({ name }) => name === this.item.name)
      ) {
        this.$router.push({ name: this.item.name });
      } else if (this.item.intents[0].intentArea == INTENT_AREA.OUTER_PAGE) {
        window.open(
          this.item.intents[0].request.url,
          this.item.intents[0].request?.request_params?.targetBlank == true
            ? '_blank'
            : '_self'
        );
      } else {
        // по кирпичикам построить свой роут?
        if (
          this.$router.history.current.params.module == this.item.name &&
          this.$router.history.current.params.url ==
            this.item.intents[0].request.url
        ) {
          store.dispatch(
            'page/loadOldPage',
            this.urlParamsToOldPage(this.item.intents[0].request.url)
          );
        } else {
          this.$router.push({
            name: '*',
            params: {
              url: this.item.intents[0].request.url,
              module: this.item.name
            }
          });
        }
      }
      store.commit('filters/setFilterAddUrl', { deleteUrl: true });
    }
  },
  components: { Picture, Icon }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.active {
  color: $grey80;

  &::before {
    content: '';
    width: 4px;
    height: 56px;
    background-color: $blue40;
    position: absolute;
    top: -16px;
    left: 0px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .item__logo {
    //работа с цветом получаемых svg
    filter: invert(12%) sepia(13%) saturate(711%) hue-rotate(165deg)
      brightness(92%) contrast(92%);
  }
}

.item {
  padding-left: 24px;
  list-style-type: none;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 32px;
  height: 24px;
  position: relative;

  span {
    cursor: pointer;
    margin-left: 24px;
  }

  &:hover:not(.active) {
    cursor: pointer;
    color: $grey80;

    &::before {
      content: '';
      width: 4px;
      height: 32px;
      background-color: $grey24;
      position: absolute;
      top: -3px;
      left: 0px;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }

  &__logo {
    filter: invert(57%) sepia(10%) saturate(567%) hue-rotate(169deg)
      brightness(90%) contrast(85%);
  }
}
</style>
